import { numericLimitForSubwayTextLineCount } from "../../../constants/subwayTextLineCountOptions";

const getSubwayViewSettingsDisplay = state => state.definitions.subwayViewSettings.get("display");
const getSubwayViewSettingsNumTextLines = state => state.definitions.subwayViewSettings.get("numTextLines");
const getSubwayViewSettingsLineCountNumericLimit = state =>
  numericLimitForSubwayTextLineCount(state.definitions.subwayViewSettings.get("numTextLines"));

export default {
  getSubwayViewSettingsDisplay,
  getSubwayViewSettingsNumTextLines,
  getSubwayViewSettingsLineCountNumericLimit
};
